import { Row } from 'hedron';
import React from 'react';
import PropTypes from 'prop-types';
import DesignerListSectionSubcolumn from './DesignerListSectionSubcolumn';
import LetterColumn from './styled/LetterColumn';
import Letter from './styled/Letter';
import DesignerListDesignersColumn from './DesignerListDesignersColumn';
import DesignerListLink from './DesignerListLink';

const DesignerListFilledSection = ({ groupedArray, letter }) => (
  <Row divisions={15}>
    <DesignerListSectionSubcolumn index={0}>
      <LetterColumn>
        <Letter>{letter}</Letter>
      </LetterColumn>
    </DesignerListSectionSubcolumn>
    {groupedArray.map((subArray, index) => (
      <DesignerListSectionSubcolumn index={index + 1}>
        <DesignerListDesignersColumn designers={subArray} />
      </DesignerListSectionSubcolumn>
    ))}
  </Row>
);

DesignerListLink.propTypes = {
  groupedArray: PropTypes.arrayOf(
    PropTypes.shape({
      alias: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ).isRequired,
  letter: PropTypes.string.isRequired,
};

export default DesignerListFilledSection;
